import { useCallback, useRef } from 'react';
import type { ThreeColGoodsListItem } from '../types';
import type { FlatListProps } from 'react-native';
import { bridge } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';

export const useLogDisplayGoods = () => {
  const goodsItemLoggedList = useRef<Array<number>>([]);

  const logDisplayGoods = useCallback<
    NonNullable<FlatListProps<ThreeColGoodsListItem>['onViewableItemsChanged']>
  >(({ viewableItems }) => {
    viewableItems.forEach(({ index, isViewable, item }) => {
      if (index === null || !isViewable) {
        return;
      }
      if (goodsItemLoggedList.current.includes(index)) {
        return;
      }
      goodsItemLoggedList.current.push(index);

      if (item.type === 'placeholder') {
        return;
      }

      const { data } = item;

      bridge.logAnalyticsEvent({
        name: 'DISPLAY_GOODS',
        analytics: data.logging.analytics,
        ably_only_log: data.logging.ably_only_log,
      });

      bridge.logAdEvent({
        action: AdAction.DISPLAY,
        ad: item.data.item.ad,
      });
    });
  }, []);

  return { logDisplayGoods };
};
